import React from 'react';
import styled from 'styled-components';
import { VehicleModelProps } from './car-model';
import { VehicleSide, VehiclePart } from '../../enums';
import VehicleStateImg from './vehicle-state-img';
import WheelImg from '../../assets/images/car-model/wheel.png';

interface Props extends VehicleModelProps {
  part: VehiclePart;
  side: VehicleSide;
}

const WHEEL_ROTATION = {
  front_left: 0,
  front_right: 90,
  rear_right: 180,
  rear_left: 270,
};

class VehicleWheel extends React.Component<Props, any> {
  getVehicleItem = () => {
    const { side, part } = this.props;
    return `${side}-${part}-wheel`;
  };

  clickHandler = () => {
    const { clickHandler } = this.props;
    clickHandler && clickHandler(this.getVehicleItem());
  };

  render() {
    const { className, vehicleState } = this.props;
    const vehicleItem = this.getVehicleItem();

    return (
      <VehicleStateImg
        className={`${className} ${vehicleState[vehicleItem]}`}
        src={WheelImg}
        onClick={this.clickHandler}
      />
    );
  }
}

const getPropName = (part: string, side: string): string => `${part}_${side}`;

const StyledVehicleWheel = styled(VehicleWheel)`
  width: 3em;
  margin: 0 0.25em;
  transform: rotate(
    ${({ part, side }) => WHEEL_ROTATION[getPropName(part, side)]}deg
  );
`;

export default StyledVehicleWheel;
